"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPriceByYearsAmount = exports.getPercentageSavings = exports.getPercentageDiscount = exports.getOptionsForTermsDropdown = exports.getOneYearTermCurrentPrice = exports.getOneYearTermCurrPriceDisplay = exports.getMultiYearPriceDiscount = exports.getMultiYearPercentageDiscount = exports.getMultiYearMonthlyPrice = exports.getMultiYearFirstYearSalePriceDisplay = exports.getMultiYearAnnualPrice = exports.getMoneySavings = exports.getLongestTermDuration = exports.getListPriceDisplayDefault = exports.getListPriceDisplay = exports.getListPriceByDiscount = exports.getListPrice = exports.getIsVatIncludedInPrice = exports.getDueTodayPrice = exports.getDiscountPriceByYearsAmount = exports.getCurrentPriceDisplay = exports.getCurrentPriceByYears = exports.getCurrentPrice = exports.getCombinedPriceDisplay = exports.getCombinedPremiumPriceDisplay = exports.getBestValue = exports.formatProductPrice = exports.formatDomainPrice = exports.convertYearlyPriceToMonthlyPrice = exports.combinePrice = exports.calculatePriceSavingsDisplay = exports.calculateFinalTermDisplay = exports.calculateDomainPrices = exports.applyPrecision = void 0;
exports.getPriceInfo = getPriceInfo;
exports.getPrices = getPrices;
exports.getYearTerm = exports.getVatPercentage = exports.getSalePriceDisplay = exports.getRenewalPrice = exports.getQualifiersTextId = void 0;
var _CurrencyHelper = require("./CurrencyHelper");
var _intlFormatter = require("@godaddy/intl-formatter");
/**
 * @function applyPrecision
 * @param {number} price The price to be converted
 * @param {string} market User's current market
 * @param {string} currency User's current currency
 * @param {object} options options
 * @param {object} options.precision the decimal place the result will be rounded to.
 * Sensitive to currency fraction digits. Default value of 10 in en-us translates to round up 2 decimals.
 * @param {object} options.ceilingOverride let us specify directly the ceiling precision round up logic.
 * eg: 10 will round up the next 10 cents (0.81 => $0.90)
 * @returns {number} adjusted price
 */
const applyPrecision = ({
  price,
  market,
  currency,
  options = {}
}) => {
  const termPrice = options.isMonthlyPrice ? price / 12 : price;
  const gdCurrency = new _intlFormatter.Currency();
  const ceiling = options.ceilingOverride ? options.ceilingOverride : Math.pow(options.precision || 10, gdCurrency.getFractionDigits(currency));
  const roundedPrice = Math.ceil(termPrice * ceiling) / ceiling;
  const formatFlags = {
    excludeDecimal: Number.isInteger(roundedPrice),
    ...options.formatFlags
  };
  const intlNumberFormatOptions = {
    ...(options.intlNumberFormatOptions || {})
  };
  return (0, _CurrencyHelper.formatCurrency)(roundedPrice, market, currency, formatFlags, intlNumberFormatOptions);
};

/**
 * @function convertYearlyPriceToMonthlyPrice
 * @param {number} price The price to be converted
 * @param {string} market User's current market
 * @param {string} currency User's current currency
 * @param {object} options options
 * @param {object} options.precision the decimal place the result will be rounded to
 * @returns {number} The monthly price
 */
exports.applyPrecision = applyPrecision;
const convertYearlyPriceToMonthlyPrice = (price, market, currency, options = {}) => {
  if (isNaN(price)) {
    return;
  }
  options.isMonthlyPrice = true;
  return applyPrecision({
    price,
    market,
    currency,
    options
  });
};
exports.convertYearlyPriceToMonthlyPrice = convertYearlyPriceToMonthlyPrice;
const combinePrice = (priceInfo, priceType) => {
  const totalPrice = priceInfo.reduce((total, price) => {
    total += price[priceType];
    return total;
  }, 0);
  return totalPrice;
};
exports.combinePrice = combinePrice;
const getCombinedPriceDisplay = (priceInfo, priceType, market, currency) => {
  const totalPrice = combinePrice(priceInfo, priceType);
  return applyPrecision({
    price: totalPrice,
    market,
    currency
  });
};
exports.getCombinedPriceDisplay = getCombinedPriceDisplay;
const getCombinedPremiumPriceDisplay = (availableDomains, market, currency) => {
  const allPremiumPrice = availableDomains.reduce((premiumPrice, domain) => {
    premiumPrice += domain.Price;
    return premiumPrice;
  }, 0);
  return applyPrecision({
    price: allPremiumPrice,
    market,
    currency
  });
};

/* TBD and combined with getCurrentPriceDisplay function below */
exports.getCombinedPremiumPriceDisplay = getCombinedPremiumPriceDisplay;
const getSalePriceDisplay = ({
  premiumPriceDisplay,
  priceInfo,
  market,
  currency,
  isPreReg,
  bundlePricing
}) => {
  const salePrice = Array.isArray(priceInfo) ? getCombinedPriceDisplay(priceInfo, 'CurrentPrice', market, currency) : priceInfo.CurrentPriceDisplay;
  if (isPreReg) {
    return priceInfo.TotalCurrentPriceDisplay;
  } else if (premiumPriceDisplay) {
    return '';
  } else if (bundlePricing) {
    return bundlePricing.CurrentPrice;
  }
  return salePrice;
};
exports.getSalePriceDisplay = getSalePriceDisplay;
const getIsVatIncludedInPrice = priceInfo => {
  return Array.isArray(priceInfo) ? priceInfo.some(price => price.IsVATIncludedInPrice) : priceInfo.IsVATIncludedInPrice;
};

/* TBD and combined with getListPriceDisplay function below */
exports.getIsVatIncludedInPrice = getIsVatIncludedInPrice;
const getListPriceDisplayDefault = ({
  premiumPriceDisplay,
  priceInfo,
  market,
  currency,
  isPreReg,
  bundlePricing
}) => {
  const listPrice = Array.isArray(priceInfo) ? getCombinedPriceDisplay(priceInfo, 'ListPrice', market, currency) : priceInfo.ListPriceDisplay;
  if (isPreReg) {
    return priceInfo.TotalCurrentPriceDisplay;
  } else if (premiumPriceDisplay) {
    return premiumPriceDisplay;
  } else if (bundlePricing) {
    return bundlePricing.ListPrice;
  }
  return listPrice;
};
exports.getListPriceDisplayDefault = getListPriceDisplayDefault;
const getRenewalPrice = (priceInfo, market, currency) => {
  if (!Array.isArray(priceInfo)) {
    return priceInfo.RenewalPriceDisplay;
  }
  const renewalPrice = priceInfo.reduce((totalRenewalPrice, price) => {
    totalRenewalPrice += price.RenewalPrice;
    return totalRenewalPrice;
  }, 0);
  return applyPrecision({
    price: renewalPrice,
    market,
    currency
  });
};
exports.getRenewalPrice = getRenewalPrice;
const getVatPercentage = priceInfo => {
  if (!Array.isArray(priceInfo)) {
    return priceInfo.VatFees;
  }
  const vatFees = priceInfo.reduce((totalVatFees, price) => {
    totalVatFees += price.VatFees;
    return totalVatFees;
  }, 0);
  return vatFees;
};
exports.getVatPercentage = getVatPercentage;
const getLongestTermDuration = priceInfo => {
  if (!Array.isArray(priceInfo)) {
    return priceInfo.PromoRegLengthFlag;
  }

  // get the highest PromoRegLengthFlag
  const promoRegLengthFlag = priceInfo.reduce((finalPromo, price) => {
    if (price.PromoRegLengthFlag > finalPromo) {
      return price.PromoRegLengthFlag;
    }
    return finalPromo;
  }, 0);
  return promoRegLengthFlag;
};
exports.getLongestTermDuration = getLongestTermDuration;
const getMultiYearPriceDiscount = (currentPrice, listPrice) => {
  return listPrice - currentPrice;
};
exports.getMultiYearPriceDiscount = getMultiYearPriceDiscount;
const getPercentageDiscount = (currentPrice, listPrice) => {
  return Math.floor((listPrice - currentPrice) / listPrice * 100);
};
exports.getPercentageDiscount = getPercentageDiscount;
const getDiscountPriceByYearsAmount = (currentPrice, listPrice, numYears = 2) => {
  return currentPrice + listPrice * (numYears - 1);
};
exports.getDiscountPriceByYearsAmount = getDiscountPriceByYearsAmount;
const getPriceByYearsAmount = (listPrice, numYears) => {
  return listPrice * numYears;
};
exports.getPriceByYearsAmount = getPriceByYearsAmount;
const getMultiYearPercentageDiscount = (currentPrice, listPrice, numYears = 2) => {
  const totalCurrentPrice = getDiscountPriceByYearsAmount(currentPrice, listPrice, numYears);
  const totalListPrice = getPriceByYearsAmount(listPrice, numYears);
  return getPercentageDiscount(totalCurrentPrice, totalListPrice);
};
exports.getMultiYearPercentageDiscount = getMultiYearPercentageDiscount;
const getMultiYearMonthlyPrice = (currentPrice, listPrice, numYears = 2) => getDiscountPriceByYearsAmount(currentPrice, listPrice, numYears) / (numYears * 12);
exports.getMultiYearMonthlyPrice = getMultiYearMonthlyPrice;
const getMultiYearAnnualPrice = (currentPrice, listPrice, numYears = 2) => getDiscountPriceByYearsAmount(currentPrice, listPrice, numYears) / numYears;
exports.getMultiYearAnnualPrice = getMultiYearAnnualPrice;
const getCurrentPriceByYears = ({
  oneYearSalePrice,
  numYears,
  minimumYears,
  listPrice,
  currentPrice
}) => {
  if (oneYearSalePrice && numYears === 1) return oneYearSalePrice;
  if (numYears < minimumYears) return listPrice;
  return currentPrice;
};
exports.getCurrentPriceByYears = getCurrentPriceByYears;
const getListPriceByDiscount = ({
  hasDiscount,
  numYears,
  listPrice,
  oneYearSalePrice,
  currentPrice
}) => {
  if (hasDiscount) return listPrice;
  if (oneYearSalePrice && numYears === 1) return oneYearSalePrice;
  return currentPrice;
};
exports.getListPriceByDiscount = getListPriceByDiscount;
const getOptionsForTermsDropdown = ({
  monthlyTerms,
  minimumYears,
  listPrice,
  currentPrice,
  oneYearSalePrice,
  hasDiscount,
  market,
  currency
}) => monthlyTerms.map(monthlyTerm => {
  const numYears = monthlyTerm / 12;
  const currentPriceByYears = getCurrentPriceByYears({
    oneYearSalePrice,
    numYears,
    minimumYears,
    listPrice,
    currentPrice
  });
  const listPriceByDiscount = getListPriceByDiscount({
    hasDiscount,
    numYears,
    listPrice,
    oneYearSalePrice,
    currentPrice
  });
  const totalCurrentPrice = getDiscountPriceByYearsAmount(currentPriceByYears, listPriceByDiscount, numYears);
  const totalListPrice = getPriceByYearsAmount(listPriceByDiscount, numYears);
  const discount = getPercentageDiscount(totalCurrentPrice, totalListPrice);
  const getMessageId = () => {
    if (numYears === 1) {
      return `pricing.dropdown.display.${discount ? 'discount.oneYear' : 'oneYear'}`;
    }
    return `pricing.dropdown.display.${discount ? 'discount.multiYear' : 'multiYear'}`;
  };
  return {
    numYears,
    totalCurrentPrice: applyPrecision({
      price: totalCurrentPrice,
      market,
      currency
    }),
    totalListPrice: applyPrecision({
      price: totalListPrice,
      market,
      currency
    }),
    discount,
    messageId: getMessageId()
  };
});
exports.getOptionsForTermsDropdown = getOptionsForTermsDropdown;
const getBestValue = options => {
  const bestValues = options.reduce((arr, {
    discount
  }) => {
    const previous = arr.find(v => v >= discount);
    if (!previous) {
      return [discount];
    }
    if (previous === discount) {
      arr.push(discount);
    }
    return arr;
  }, []);
  return bestValues.length === 1 ? bestValues[0] : null;
};
exports.getBestValue = getBestValue;
const calculateDomainPrices = ({
  currentPrice,
  listPrice,
  termLength,
  market,
  currency
}) => {
  const multiYearMonthlyPriceDisplay = applyPrecision({
    price: getMultiYearMonthlyPrice(currentPrice, listPrice, termLength),
    market,
    currency,
    options: {
      ceilingOverride: 1000
    }
  });
  const multiYearAnnualPriceDisplay = applyPrecision({
    price: getMultiYearAnnualPrice(currentPrice, listPrice, termLength),
    market,
    currency,
    options: {
      ceilingOverride: 1000
    }
  });
  const multiYearPriceSavingsDisplay = applyPrecision({
    price: getMultiYearPriceDiscount(currentPrice, listPrice),
    market,
    currency
  });
  const multiYearTotalDueTodayDisplay = applyPrecision({
    price: getDiscountPriceByYearsAmount(currentPrice, listPrice, termLength),
    market,
    currency
  });
  const multiYearPriceDiscountDisplay = getMultiYearPercentageDiscount(currentPrice, listPrice, termLength);
  return {
    multiYearMonthlyPriceDisplay,
    multiYearAnnualPriceDisplay,
    multiYearPriceSavingsDisplay,
    multiYearPriceDiscountDisplay,
    multiYearTotalDueTodayDisplay
  };
};
exports.calculateDomainPrices = calculateDomainPrices;
const formatProductPrice = (product, customOptions) => {
  const options = {
    ceilingOverride: 1000,
    ...customOptions
  };
  return product ? {
    ...product,
    PriceInfo: {
      ...product.PriceInfo,
      AdditionalYearsPriceDisplay: applyPrecision({
        price: product.PriceInfo.AdditionalYearsPrice,
        options
      }),
      CurrentPriceDisplay: applyPrecision({
        price: product.PriceInfo.CurrentPrice,
        options
      }),
      ListPriceDisplay: applyPrecision({
        price: product.PriceInfo.ListPrice,
        options
      }),
      OneYearSalePriceDisplay: applyPrecision({
        price: product.PriceInfo.OneYearSalePrice,
        options
      }),
      RenewalPriceDisplay: applyPrecision({
        price: product.PriceInfo.RenewalPrice,
        options
      }),
      TotalCurrentPriceDisplay: applyPrecision({
        price: product.PriceInfo.TotalCurrentPrice,
        options
      }),
      TotalListPriceDisplay: applyPrecision({
        price: product.PriceInfo.TotalListPrice,
        options
      })
    }
  } : {};
};
exports.formatProductPrice = formatProductPrice;
const formatDomainPrice = (domain, customOptions) => domain ? {
  ...domain,
  PriceDisplay: domain.Price ? applyPrecision({
    price: domain.Price,
    options: customOptions
  }) : domain.PriceDisplay
} : {};

// https://github.com/gdcorp-site/site-library/blob/main/packages/components/domain-search-result/src/utilities/PriceHelper.js and
exports.formatDomainPrice = formatDomainPrice;
function getPriceInfo(products, tld, tierId) {
  return products.find(product => product.Tld === tld && product.TierId === tierId)?.PriceInfo;
}
function getPrices(priceInfo) {
  const hasSalePrice = priceInfo.CurrentPrice !== priceInfo.ListPrice;
  const listDisplay = priceInfo.ListPriceDisplay;
  const saleDisplay = priceInfo.CurrentPriceDisplay;
  return {
    saleDisplay,
    listDisplay,
    hasSalePrice
  };
}

/* https://github.com/gdcorp-site/site-library/blob/main/packages/components/pricing/src/utilities/HelperUtilities.js */
const getPercentageSavings = (currentPrice, listPrice) => {
  return Math.floor(100 - currentPrice * 100 / listPrice);
};
exports.getPercentageSavings = getPercentageSavings;
const getMoneySavings = (currentPrice, listPrice) => {
  return listPrice - currentPrice;
};
exports.getMoneySavings = getMoneySavings;
const getCurrentPriceDisplay = ({
  premiumPriceDisplay,
  currentPriceDisplayOverride,
  CurrentPriceDisplay,
  messages,
  isFree,
  isAuctionOrAftermarketPremium,
  showTwoLinePrice,
  formatMessage,
  showMonthlyPriceForATMP
}) => {
  const currentPriceDisplay = currentPriceDisplayOverride ? currentPriceDisplayOverride : CurrentPriceDisplay;
  const freeLabel = showTwoLinePrice ? formatMessage({
    id: messages.freeLabel
  }) : formatMessage({
    id: messages.freeLabel
  }).toUpperCase();
  const currPriceDisplay = isFree ? freeLabel : currentPriceDisplay;
  if (showMonthlyPriceForATMP) {
    return formatMessage({
      id: 'pricing.display.price-per-month'
    }, {
      price: currPriceDisplay
    });
  }
  return isAuctionOrAftermarketPremium ? premiumPriceDisplay : currPriceDisplay;
};
exports.getCurrentPriceDisplay = getCurrentPriceDisplay;
const getCurrentPrice = ({
  premiumPrice,
  currentPriceOverride,
  CurrentPrice,
  isFree,
  isAuctionOrAftermarketPremium
}) => {
  const currentPriceValue = currentPriceOverride ? currentPriceOverride : CurrentPrice;
  const currPrice = isFree ? 0 : currentPriceValue;
  return isAuctionOrAftermarketPremium ? premiumPrice : currPrice;
};
exports.getCurrentPrice = getCurrentPrice;
const getOneYearTermCurrentPrice = ({
  OneYearSalePrice,
  currentPrice
}) => {
  return OneYearSalePrice || currentPrice;
};
exports.getOneYearTermCurrentPrice = getOneYearTermCurrentPrice;
const getOneYearTermCurrPriceDisplay = ({
  OneYearSalePriceDisplay,
  currentPriceDisplay
}) => {
  return OneYearSalePriceDisplay || currentPriceDisplay;
};
exports.getOneYearTermCurrPriceDisplay = getOneYearTermCurrPriceDisplay;
const getListPriceDisplay = ({
  initialPriceDisplayOverride,
  isAuctionOrAftermarketPremium,
  ListPrice,
  currentPrice,
  ListPriceDisplay,
  showTwoLinePrice
}) => {
  if (initialPriceDisplayOverride) {
    return initialPriceDisplayOverride;
  }
  const shouldListPriceBeNull = isAuctionOrAftermarketPremium || ListPrice === currentPrice;
  if (shouldListPriceBeNull && showTwoLinePrice) {
    // for reg premium we want to display listprice for 2 year term
    return ListPriceDisplay;
  }
  return shouldListPriceBeNull ? null : ListPriceDisplay;
};
exports.getListPriceDisplay = getListPriceDisplay;
const getListPrice = ({
  initialPriceOverride,
  isAuctionOrAftermarketPremium,
  ListPrice,
  RenewalPrice,
  currentPrice,
  showTwoLinePrice
}) => {
  if (initialPriceOverride) {
    return initialPriceOverride;
  }
  const shouldListPriceBeNull = isAuctionOrAftermarketPremium && ListPrice === RenewalPrice || ListPrice === currentPrice;
  if (shouldListPriceBeNull && showTwoLinePrice) {
    return ListPrice;
  }
  return shouldListPriceBeNull ? 0 : ListPrice;
};
exports.getListPrice = getListPrice;
const getDueTodayPrice = ({
  forceOneYearDisplay,
  actualCurrentPrice,
  listPrice,
  showTwoLinePrice,
  isAuctionOrAftermarketPremium,
  RenewalPrice
}) => {
  if (showTwoLinePrice && isAuctionOrAftermarketPremium) {
    return (0, _CurrencyHelper.formatCurrency)(actualCurrentPrice + RenewalPrice);
  }
  if (!isAuctionOrAftermarketPremium) {
    return forceOneYearDisplay ? (0, _CurrencyHelper.formatCurrency)(actualCurrentPrice) : (0, _CurrencyHelper.formatCurrency)(actualCurrentPrice + listPrice);
  }
  return null;
};
exports.getDueTodayPrice = getDueTodayPrice;
const calculatePriceSavingsDisplay = ({
  actualCurrentPrice,
  listPrice,
  percentageSavingsMessage,
  moneySavingsMessage,
  displayPercentagePrice,
  isAuctionOrAftermarketPremium,
  formatMessage
}) => {
  const hasDiscount = listPrice !== 0 && listPrice !== actualCurrentPrice;
  if (!hasDiscount || isAuctionOrAftermarketPremium) {
    return null;
  }
  const percentageSavings = getPercentageSavings(actualCurrentPrice, listPrice);
  const moneySavings = (0, _CurrencyHelper.formatCurrency)(getMoneySavings(actualCurrentPrice, listPrice));
  const percentSavingsDisplay = displayPercentagePrice && percentageSavingsMessage && formatMessage({
    id: percentageSavingsMessage
  }, {
    percentage: percentageSavings
  });
  const moneySavingsDisplay = !displayPercentagePrice && moneySavingsMessage && formatMessage({
    id: moneySavingsMessage
  }, {
    money: moneySavings
  });
  return percentSavingsDisplay || moneySavingsDisplay || null;
};
exports.calculatePriceSavingsDisplay = calculatePriceSavingsDisplay;
const getQualifiersTextId = auctionTypeId => {
  switch (auctionTypeId) {
    case 13:
    case 14:
    case 16:
    case 25:
    case 37:
    case 38:
      return `pricing.qualifiers.bid`;
    case 9:
    case 33:
      return `pricing.qualifiers.offer`;
    case 20:
    case 39:
      return `pricing.qualifiers.bargain`;
    default:
      return null;
  }
};
exports.getQualifiersTextId = getQualifiersTextId;
const getYearTerm = term => {
  return term / 12;
};
exports.getYearTerm = getYearTerm;
const getMultiYearFirstYearSalePriceDisplay = (term, PriceInfo = {}) => {
  const yearTermLength = term && getYearTerm(term);
  const {
    MultiYearPricing
  } = PriceInfo;
  const multiYearTermDisplay = MultiYearPricing?.find(item => item.Term === yearTermLength)?.FirstYearSalePriceDisplay;
  return multiYearTermDisplay;
};
exports.getMultiYearFirstYearSalePriceDisplay = getMultiYearFirstYearSalePriceDisplay;
const calculateFinalTermDisplay = (term, PriceInfo = {}) => {
  const {
    PromoRegLengthFlag
  } = PriceInfo;
  const yearTermLength = term && getYearTerm(term);
  if (yearTermLength >= 1 && PromoRegLengthFlag > 1 && yearTermLength < PromoRegLengthFlag) {
    return yearTermLength;
  }
};
exports.calculateFinalTermDisplay = calculateFinalTermDisplay;